<template>
  <div>
    <span
      :class="[
        {
          'has-text-weight-bold': option.isSelected,
          'has-text-weight-medium': !option.isSelected
        },
        {
          'has-text-grey-dark':
            $mq === 'mobile' || (option.isSelected && $mq !== 'mobile')
        }
      ]"
      >{{ option.title }}
    </span>
  </div>
</template>

<script>
export default {
  name: 'DashboardSearchOption',
  props: {
    option: {
      type: Object,
      required: true
    }
  },
  computed: {
    colour() {
      return this.option.isSelected ? 'orange' : 'celadon'
    }
  }
}
</script>
